var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "offer-pdf m-auto" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("hr", { staticClass: "offer-pdf__divider" }),
      _vm._v(" "),
      _c("h4", { staticClass: "offer-pdf__headline" }, [_vm._v("Angebot")]),
      _vm._v(" "),
      _c("h1", { staticClass: "offer-pdf__main-headline" }, [
        _vm.offer.firma != ""
          ? _c("span", [_vm._v(_vm._s(_vm.offer.firma))])
          : _c("span", [
              _vm._v(
                _vm._s(_vm.offer.salutation) + " " + _vm._s(_vm.offer.name)
              )
            ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "offer-pdf__sub-headline" }, [
        _vm._v(
          "Angebotsnummer: " +
            _vm._s(new Date().getFullYear()) +
            " - " +
            _vm._s(_vm.offer.id)
        )
      ]),
      _vm._v(" "),
      _vm.offer.client_id > 0 ||
      (_vm.offer.street != "" && _vm.offer.zip != "" && _vm.offer.city != "")
        ? _c("div", { staticClass: "row offer-pdf__address" }, [
            _c("div", { staticClass: "col-6" }, [
              _vm.offer.client
                ? _c("div", [
                    _vm.offer.client.company != ""
                      ? _c("b", { staticClass: "d-block" }, [
                          _vm._v(_vm._s(_vm.offer.client.company))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("b", [
                      _vm._v(_vm._s(_vm.offer.client.user.salutation)),
                      _vm.offer.client.user.pre_name
                        ? _c("span", [
                            _vm._v(" " + _vm._s(_vm.offer.client.user.pre_name))
                          ])
                        : _vm._e(),
                      _vm._v(" " + _vm._s(_vm.offer.client.user.name))
                    ]),
                    _c("br"),
                    _vm._v(
                      "\n                " + _vm._s(_vm.offer.client.street)
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.offer.client.zip) +
                        " " +
                        _vm._s(_vm.offer.client.city)
                    ),
                    _c("br")
                  ])
                : _c("div", [
                    _vm.offer.firma != ""
                      ? _c("b", [_vm._v(_vm._s(_vm.offer.firma))])
                      : _c("b", [_vm._v(_vm._s(_vm.offer.name))]),
                    _c("br"),
                    _vm._v("\n                " + _vm._s(_vm.offer.street)),
                    _c("br"),
                    _vm._v("\n                " + _vm._s(_vm.offer.zip)),
                    _c("br"),
                    _vm._v("\n                " + _vm._s(_vm.offer.city)),
                    _c("br")
                  ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6" }, [
              _c("b", [_vm._v("Capture Studio")]),
              _c("br"),
              _vm._v("\n            " + _vm._s(_vm.manager.full_name)),
              _c("br"),
              _vm._v("\n            Lauchstädter Str. 42a"),
              _c("br"),
              _vm._v("\n            04229 Leipzig"),
              _c("br"),
              _vm._v("\n            Deutschland\n        ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.offerTexts, function(offerPart) {
        return _c(
          "div",
          {
            staticClass: "offer-pdf__item",
            class: offerPart.type_id == 1 ? "offer-pdf__item--break" : ""
          },
          [
            offerPart.type_id != 5
              ? _c("div", [
                  _c("h4", { staticClass: "offer-pdf__headline" }, [
                    _vm._v(_vm._s(offerPart.headline))
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "offer-pdf__text",
                    domProps: { innerHTML: _vm._s(offerPart.template) }
                  }),
                  _vm._v(" "),
                  offerPart.type_id == 1 && _vm.manager.name == "Sascha"
                    ? _c("div", { staticClass: "offer-pdf__user-image" }, [
                        _c("img", {
                          attrs: {
                            alt: "",
                            width: "150",
                            src:
                              "https://admin.produktfotografie-24h.de/img/sascha-1.jpg"
                          }
                        })
                      ])
                    : offerPart.type_id == 1 && _vm.manager.name == "Franzi"
                    ? _c("div", { staticClass: "offer-pdf__user-image" }, [
                        _c("img", {
                          attrs: {
                            alt: "",
                            width: "150",
                            src:
                              "https://admin.produktfotografie-24h.de/img/franzi-1.jpg"
                          }
                        })
                      ])
                    : offerPart.type_id == 1 && _vm.manager.name == "Daniela"
                    ? _c("div", { staticClass: "offer-pdf__user-image" }, [
                        _c("img", {
                          attrs: {
                            alt: "",
                            width: "150",
                            src:
                              "https://admin.produktfotografie-24h.de/img/danie-1.jpg"
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  offerPart.type_id == 1
                    ? _c("div", { staticClass: "row offer-pdf__service" }, [
                        _vm._m(1, true),
                        _vm._v(" "),
                        _vm._m(2, true)
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  offerPart.headline && offerPart.headline.includes("Legeware")
                    ? _c("div", [
                        _c("p", { staticClass: "mt-5 font-weight-bold" }, [
                          _vm._v("Beispiel Bilder")
                        ]),
                        _vm._v(" "),
                        _vm._m(3, true)
                      ])
                    : offerPart.headline &&
                      offerPart.headline.includes("Flaschen")
                    ? _c("div", [
                        _c("p", { staticClass: "mt-5 font-weight-bold" }, [
                          _vm._v("Beispiel Bilder")
                        ]),
                        _vm._v(" "),
                        _vm._m(4, true)
                      ])
                    : _vm._e()
                ])
              : _c("div", { staticClass: "offer-pdf__item-price" }, [
                  offerPart.headline
                    ? _c("h4", {
                        staticClass: "offer-pdf__headline",
                        domProps: { innerHTML: _vm._s(offerPart.headline) }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "offer-pdf__text offer-pdf__text--price",
                    domProps: { innerHTML: _vm._s(offerPart.template_short) }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "offer-pdf__text offer-pdf__text--price" },
                    [
                      _vm._v(
                        " Das Angebot bezieht sich auf ein Volumen von " +
                          _vm._s(_vm.offer.estimation_range) +
                          " Bildern."
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row offer-pdf__price-row-headline mt-3" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "offer-pdf__price-vert-headline",
                          class:
                            _vm.offerTemplate.project_type_id == 21
                              ? "col-3"
                              : "col-6"
                        },
                        [_vm._v("Unsere Servicepakete")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class:
                            _vm.offerTemplate.project_type_id == 21
                              ? "col-9"
                              : "col-6"
                        },
                        [
                          offerPart.template.priceCols == 3
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "row offer-pdf__price-headline-row"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "offer-pdf__price-headline-item col-4 text-right"
                                    },
                                    [_vm._v("Basic")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "offer-pdf__price-headline-item col-4 text-right"
                                    },
                                    [_vm._v("Standard")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "offer-pdf__price-headline-item col-4 text-right"
                                    },
                                    [_vm._v("Premium")]
                                  )
                                ]
                              )
                            : offerPart.template.priceCols == 2
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "row offer-pdf__price-headline-row"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "offer-pdf__price-headline-item col-6 text-right"
                                    },
                                    [_vm._v("Standard")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "offer-pdf__price-headline-item col-6 text-right"
                                    },
                                    [_vm._v("Premium")]
                                  )
                                ]
                              )
                            : offerPart.template.priceCols == 1
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "row offer-pdf__price-headline-row"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "offer-pdf__price-headline-item col-12 text-right"
                                    },
                                    [_vm._v("Features")]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.offerTemplate.project_type_id == 21
                    ? _c(
                        "div",
                        _vm._l(offerPart.template.texts, function(item) {
                          return _c(
                            "div",
                            { staticClass: "offer-pdf__price-row row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-3 offer-pdf__price-vert-headline"
                                },
                                [_vm._v(_vm._s(item.name))]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-9" }, [
                                offerPart.template.priceCols == 1
                                  ? _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "offer-pdf__price-item col-12 text-right"
                                        },
                                        [
                                          item.price1 == "true"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-check-circle"
                                                })
                                              ])
                                            : item.price1 == "false"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-times-circle"
                                                })
                                              ])
                                            : _c("span", [
                                                _vm._v(_vm._s(item.price1))
                                              ])
                                        ]
                                      )
                                    ])
                                  : offerPart.template.priceCols == 2
                                  ? _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "offer-pdf__price-item col-6 text-right"
                                        },
                                        [
                                          item.price1 == "true"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-check-circle"
                                                })
                                              ])
                                            : item.price1 == "false"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-times-circle"
                                                })
                                              ])
                                            : _c("span", [
                                                _vm._v(_vm._s(item.price1))
                                              ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "offer-pdf__price-item col-6 text-right"
                                        },
                                        [
                                          item.price2 == "true"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-check-circle"
                                                })
                                              ])
                                            : item.price2 == "false"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-times-circle"
                                                })
                                              ])
                                            : _c("span", [
                                                _vm._v(_vm._s(item.price2))
                                              ])
                                        ]
                                      )
                                    ])
                                  : offerPart.template.priceCols == 3
                                  ? _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "offer-pdf__price-item col-4 text-right"
                                        },
                                        [
                                          item.price1 == "true"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-check-circle"
                                                })
                                              ])
                                            : item.price1 == "false"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-times-circle"
                                                })
                                              ])
                                            : _c("span", [
                                                _vm._v(_vm._s(item.price1))
                                              ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "offer-pdf__price-item col-4 text-right"
                                        },
                                        [
                                          item.price2 == "true"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-check-circle"
                                                })
                                              ])
                                            : item.price2 == "false"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-times-circle"
                                                })
                                              ])
                                            : _c("span", [
                                                _vm._v(_vm._s(item.price2))
                                              ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "offer-pdf__price-item col-4 text-right"
                                        },
                                        [
                                          item.price3 == "true"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-check-circle"
                                                })
                                              ])
                                            : item.price3 == "false"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-times-circle"
                                                })
                                              ])
                                            : _c("span", [
                                                _vm._v(_vm._s(item.price3))
                                              ])
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    : _c(
                        "div",
                        _vm._l(offerPart.template.texts, function(item) {
                          return _c(
                            "div",
                            { staticClass: "offer-pdf__price-row row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-6 offer-pdf__price-vert-headline"
                                },
                                [_vm._v(_vm._s(item.name))]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-6" }, [
                                offerPart.template.priceCols == 1
                                  ? _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "offer-pdf__price-item col-12 text-right"
                                        },
                                        [
                                          item.price1 == "true"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-check-circle"
                                                })
                                              ])
                                            : item.price1 == "false"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-times-circle"
                                                })
                                              ])
                                            : _c("span", [
                                                _vm._v(_vm._s(item.price1))
                                              ])
                                        ]
                                      )
                                    ])
                                  : offerPart.template.priceCols == 2
                                  ? _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "offer-pdf__price-item col-6 text-right"
                                        },
                                        [
                                          item.price1 == "true"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-check-circle"
                                                })
                                              ])
                                            : item.price1 == "false"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-times-circle"
                                                })
                                              ])
                                            : _c("span", [
                                                _vm._v(_vm._s(item.price1))
                                              ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "offer-pdf__price-item col-6 text-right"
                                        },
                                        [
                                          item.price2 == "true"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-check-circle"
                                                })
                                              ])
                                            : item.price2 == "false"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-times-circle"
                                                })
                                              ])
                                            : _c("span", [
                                                _vm._v(_vm._s(item.price2))
                                              ])
                                        ]
                                      )
                                    ])
                                  : offerPart.template.priceCols == 3
                                  ? _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "offer-pdf__price-item col-4 text-right"
                                        },
                                        [
                                          item.price1 == "true"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-check-circle"
                                                })
                                              ])
                                            : item.price1 == "false"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-times-circle"
                                                })
                                              ])
                                            : _c("span", [
                                                _vm._v(_vm._s(item.price1))
                                              ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "offer-pdf__price-item col-4 text-right"
                                        },
                                        [
                                          item.price2 == "true"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-check-circle"
                                                })
                                              ])
                                            : item.price2 == "false"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-times-circle"
                                                })
                                              ])
                                            : _c("span", [
                                                _vm._v(_vm._s(item.price2))
                                              ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "offer-pdf__price-item col-4 text-right"
                                        },
                                        [
                                          item.price3 == "true"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-check-circle"
                                                })
                                              ])
                                            : item.price3 == "false"
                                            ? _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-times-circle"
                                                })
                                              ])
                                            : _c("span", [
                                                _vm._v(_vm._s(item.price3))
                                              ])
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ]
                          )
                        }),
                        0
                      ),
                  _vm._v(" "),
                  _vm.offerTemplate.project_type_id == 21
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-3 offer-pdf__price-footer-item offer-pdf__price-vert-headline"
                          },
                          [_vm._v("Paketpreis")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-9" }, [
                          offerPart.template.priceCols == 1
                            ? _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "offer-pdf__price-footer-item col-12 text-right"
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getPrice(
                                            offerPart.template.price1,
                                            _vm.imagePriceCalc
                                          ) + " &euro;"
                                        )
                                      }
                                    })
                                  ]
                                )
                              ])
                            : offerPart.template.priceCols == 2
                            ? _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "offer-pdf__price-footer-item col-6 text-right"
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getPrice(
                                            offerPart.template.price1,
                                            _vm.imagePriceCalc
                                          ) + " &euro;"
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "offer-pdf__price-footer-item col-6 text-right"
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getPrice(
                                            offerPart.template.price2,
                                            _vm.imagePriceCalc
                                          ) + " &euro;"
                                        )
                                      }
                                    })
                                  ]
                                )
                              ])
                            : offerPart.template.priceCols == 3
                            ? _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "offer-pdf__price-footer-item col-4 text-right"
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getPrice(
                                            offerPart.template.price1,
                                            _vm.imagePriceCalc
                                          ) + " &euro;"
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "offer-pdf__price-footer-item col-4 text-right"
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getPrice(
                                            offerPart.template.price2,
                                            _vm.imagePriceCalc
                                          ) + " &euro;"
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "offer-pdf__price-footer-item col-4 text-right"
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getPrice(
                                            offerPart.template.price3,
                                            _vm.imagePriceCalc
                                          ) + " &euro;"
                                        )
                                      }
                                    })
                                  ]
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-6 offer-pdf__price-footer-item offer-pdf__price-vert-headline"
                          },
                          [_vm._v("Preis pro Bild")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6" }, [
                          offerPart.template.priceCols == 1
                            ? _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "offer-pdf__price-footer-item col-12 text-right"
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getPrice(
                                            offerPart.template.price1,
                                            _vm.imagePriceCalc
                                          ) + " &euro;"
                                        )
                                      }
                                    })
                                  ]
                                )
                              ])
                            : offerPart.template.priceCols == 2
                            ? _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "offer-pdf__price-footer-item col-6 text-right"
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getPrice(
                                            offerPart.template.price1,
                                            _vm.imagePriceCalc
                                          ) + " &euro;"
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "offer-pdf__price-footer-item col-6 text-right"
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getPrice(
                                            offerPart.template.price2,
                                            _vm.imagePriceCalc
                                          ) + " &euro;"
                                        )
                                      }
                                    })
                                  ]
                                )
                              ])
                            : offerPart.template.priceCols == 3
                            ? _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "offer-pdf__price-footer-item col-4 text-right"
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getPrice(
                                            offerPart.template.price1,
                                            _vm.imagePriceCalc
                                          ) + " &euro;"
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "offer-pdf__price-footer-item col-4 text-right"
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getPrice(
                                            offerPart.template.price2,
                                            _vm.imagePriceCalc
                                          ) + " &euro;"
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "offer-pdf__price-footer-item col-4 text-right"
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getPrice(
                                            offerPart.template.price3,
                                            _vm.imagePriceCalc
                                          ) + " &euro;"
                                        )
                                      }
                                    })
                                  ]
                                )
                              ])
                            : _vm._e()
                        ])
                      ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "offer-pdf__price-options" },
                    [
                      _c(
                        "div",
                        { staticClass: "offer-pdf__price-option-headline" },
                        [_vm._v("Optionale Zusatzoptionen")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.upselling, function(option) {
                        return option.active
                          ? _c(
                              "div",
                              { staticClass: "offer-pdf__price-option-item" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "offer-pdf__price-option-item--name"
                                  },
                                  [_vm._v(_vm._s(option.name))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "offer-pdf__price-option-item--price"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm._f("currency")(option.price)) +
                                        " pro " +
                                        _vm._s(option.unit)
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "offer-pdf__vat mt-5" }, [
                    _vm._v("* alle Preisangaben zzgl. MwSt.")
                  ])
                ])
          ]
        )
      }),
      _vm._v(" "),
      _vm._m(5)
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "offer-pdf__header" }, [
      _c("img", {
        attrs: {
          alt: "",
          width: "200",
          src: "https://www.capture-studio.de/images/capture-studio.jpg"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "offer-pdf__user-image col-2" }, [
      _c("img", {
        attrs: {
          alt: "",
          height: "100",
          src: "https://admin.produktfotografie-24h.de/img/service-2.png"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "offer-pdf__user-image col-2" }, [
      _c("img", {
        attrs: {
          alt: "",
          width: "100",
          src: "https://admin.produktfotografie-24h.de/img/service-1.png"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-3" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src:
              "https://admin.produktfotografie-24h.de/img/examples/legeware-1.jpg",
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-3" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src:
              "https://admin.produktfotografie-24h.de/img/examples/legeware-2.jpg",
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-3" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src:
              "https://admin.produktfotografie-24h.de/img/examples/legeware-3.jpg",
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-3" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src:
              "https://admin.produktfotografie-24h.de/img/examples/legeware-4.jpg",
            alt: ""
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-3" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src:
              "https://admin.produktfotografie-24h.de/img/examples/flaschen-1.jpg",
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-3" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src:
              "https://admin.produktfotografie-24h.de/img/examples/flaschen-2.jpg",
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-3" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src:
              "https://admin.produktfotografie-24h.de/img/examples/flaschen-3.jpg",
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-3" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src:
              "https://admin.produktfotografie-24h.de/img/examples/flaschen-4.jpg",
            alt: ""
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "offer-pdf__item" }, [
      _c("h4", { staticClass: "offer-pdf__headline" }, [
        _vm._v("Auftragsbestätigung")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "offer-pdf__text" }, [
        _vm._v(
          "Hiermit erklären Sie sich mit dem Angebot von Capture Studio einverstanden."
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "offer-pdf__sign row justify-content-between  ml-0 mr-0"
        },
        [
          _c("div", { staticClass: "offer-pdf__offer-confirm col-4" }),
          _vm._v(" "),
          _c("div", { staticClass: "offer-pdf__offer-confirm col-4" })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "offer-pdf__sign-label row justify-content-between ml-0 mr-0"
        },
        [
          _c(
            "div",
            { staticClass: "offer-pdf__offer-confirm-text col-4 pl-0" },
            [_vm._v("Ort, Datum")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "offer-pdf__offer-confirm-text col-4 pl-0" },
            [_vm._v("Unterschrift")]
          )
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }